/*
 * @@Author: zhouwei
 * @Date: 2024-08-13 10:03:39
 * @Description:
 */
import React from 'react';
import Cookies from 'js-cookie';
import { Provider } from 'mobx-react';
import { createRoot } from 'react-dom/client';
import { LocaleProvider } from '@ok/blade';

import rootStore from '../common/stores';

import Routers from './routers';

import 'react-select-okjp/dist/react-select.css';
import '_common/less/index.less';
import '_common/fonts/iconfont-OKJ-Account.css';
// 旧的@ok/Dialog、@ok/Alert使用到的字体图标，升级后需要移除该css
import '_common/fonts/iconfont.css';

const DEFAULT_LANG = 'ja_jp';
// cookie 中的 locale 可能为空，或是连字符格式（如 zh-CN），统一归一化为下划线小写以匹配 local 文件名（zh_cn）
const normalizeLang = (locale?: string) => {
  return (locale || DEFAULT_LANG).toLowerCase().replace(/-/g, '_');
};

const renderApp = (localeData: Record<string, string>) => {
  const root = createRoot(document.querySelector('#app'));
  root.render(
    <Provider {...rootStore}>
      <LocaleProvider
        localeData={localeData}
        normalCsr
        noRemoteData
        fetchConfig={{
          project: 'okj_account_main',
          site: 'common',
        }}
      >
        {Routers}
      </LocaleProvider>
    </Provider>
  );
};

const lang = normalizeLang(Cookies.get('locale'));

import(`../local/${lang}`)
  .then((data) => {
    return renderApp(data.default);
  })
  // 未知/异常 locale 时回退到默认语言，避免应用无法渲染而白屏
  .catch(() => {
    if (lang === DEFAULT_LANG) return;
    import(`../local/${DEFAULT_LANG}`)
      .then((data) => {
        return renderApp(data.default);
      })
      .catch((e) => {
        // 默认语言也加载失败：保留诊断线索，避免再次出现"无报错白屏"
        // eslint-disable-next-line no-console
        console.error('locale fallback failed', e);
      });
  });
